var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"32bbecd6dfcd77f3ddc6ebb5dc0154f43f836641"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["union-church-website@alvaro-goede"]={id:"32bbecd6dfcd77f3ddc6ebb5dc0154f43f836641"};
      